module.exports = __webpack_public_path__ + "public/images/SP_banner_corner image.e1991db5e8e3a09a30b91f714782fcdf.png";